// Unified tracking helper: routes events to Meta Pixel (fbq), GA4 (gtag) and GTM (dataLayer).
// Meta standard events must use fbq('track', ...); everything else uses trackCustom.
const META_STANDARD = new Set([
    "PageView", "ViewContent", "Search", "AddToCart", "AddToWishlist",
    "InitiateCheckout", "AddPaymentInfo", "Purchase", "Lead",
    "CompleteRegistration", "Contact", "CustomizeProduct", "Donate",
    "FindLocation", "Schedule", "StartTrial", "SubmitApplication", "Subscribe",
]);

export function track(event, params = {}, opts = {}) {
    // Meta requires a numeric value (> 0) with a currency for commerce events.
    if (params && params.value !== undefined) {
        const n = Number(params.value);
        params = { ...params, value: Number.isFinite(n) && n > 0 ? n : undefined };
        if (params.value === undefined) delete params.value;
    }
    // eventID enables Meta browser<->server (Conversion API) deduplication.
    const fbOpts = opts && opts.eventID ? { eventID: opts.eventID } : undefined;
    try {
        if (window.fbq) {
            if (META_STANDARD.has(event)) window.fbq("track", event, params, fbOpts);
            else window.fbq("trackCustom", event, params, fbOpts);
        }
    } catch { /* noop */ }
    try { if (window.gtag) window.gtag("event", event, params); } catch { /* noop */ }
    try { if (window.dataLayer) window.dataLayer.push({ event, ...params, event_id: opts?.eventID }); } catch { /* noop */ }
}

export function newEventId() {
    try { if (window.crypto?.randomUUID) return window.crypto.randomUUID(); } catch { /* noop */ }
    return "evt_" + Date.now() + "_" + Math.random().toString(36).slice(2, 10);
}

export function trackPageView(path) {
    const page_path = path || window.location.pathname + window.location.search;
    try { if (window.fbq) window.fbq("track", "PageView"); } catch { /* noop */ }
    try { if (window.gtag) window.gtag("event", "page_view", { page_path }); } catch { /* noop */ }
    try { if (window.dataLayer) window.dataLayer.push({ event: "page_view", page_path }); } catch { /* noop */ }
}

// Meta browser cookies — passed to the backend so the server-side Conversion API
// Lead matches the same person and dedupes with the browser Pixel event.
function readCookie(name) {
    try {
        const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
        return m ? decodeURIComponent(m[1]) : "";
    } catch { return ""; }
}
export function getFbp() { return readCookie("_fbp"); }
export function getFbc() {
    const c = readCookie("_fbc");
    if (c) return c;
    try {
        const id = new URLSearchParams(window.location.search).get("fbclid");
        if (id) return `fb.1.${Date.now()}.${id}`;
    } catch { /* noop */ }
    return "";
}
